// extracted by mini-css-extract-plugin
export default {"button":"Button_button__ImPC3","primary":"Button_primary__WvU0v","secondary":"Button_secondary__AA+Q3","ghost":"Button_ghost__qFxgN"};